"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomChain = exports.ConsensusAlgorithm = exports.ConsensusType = exports.Hardfork = exports.Chain = void 0;
/*
This file is part of web3.js.

web3.js is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

web3.js is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
var Chain;
(function (Chain) {
    Chain[Chain["Mainnet"] = 1] = "Mainnet";
})(Chain || (exports.Chain = Chain = {}));
var Hardfork;
(function (Hardfork) {
    Hardfork["Zond"] = "zond";
})(Hardfork || (exports.Hardfork = Hardfork = {}));
var ConsensusType;
(function (ConsensusType) {
    ConsensusType["ProofOfStake"] = "pos";
})(ConsensusType || (exports.ConsensusType = ConsensusType = {}));
var ConsensusAlgorithm;
(function (ConsensusAlgorithm) {
    ConsensusAlgorithm["Casper"] = "casper";
})(ConsensusAlgorithm || (exports.ConsensusAlgorithm = ConsensusAlgorithm = {}));
var CustomChain;
(function (CustomChain) {
    // NOTE(rgeraldes24): one entry is required for now
    CustomChain["CustomQRL"] = "custom-qrl";
})(CustomChain || (exports.CustomChain = CustomChain = {}));
//# sourceMappingURL=enums.js.map